import { getApiActionTypes } from '../storeHelpers';

export const fetchFormDataTypes = getApiActionTypes('VIEW_TAX_RETURN/FETCH_FORM_DATA');
export const downloadFormPdfTypes = getApiActionTypes('VIEW_TAX_RETURN/DOWNLOAD_FORM_PDF');
export const RESET_FORM_DATA = 'VIEW_TAX_RETURN/RESET_FORM_DATA';
export const SELECT_MEMBER_OR_FORM_INSTANCE_ID =
  'VIEW_TAX_RETURN/SELECT_MEMBER_OR_FORM_INSTANCE_ID';
